module.exports = __webpack_public_path__ + "img/T10EM2.3410202a.png";